import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5988d9db&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./assets/css/maps.scss?vue&type=style&index=0&id=5988d9db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988d9db",
  null
  
)

export default component.exports